<app-nav></app-nav>
<router-outlet></router-outlet>
<app-footer></app-footer>